<template>
  <CHeader fixed light>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <div class="header-dashboard-title d-md-down-none">
      {{ currentPageTitle }}
    </div>
    <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <div class="c-sidebar-brand-full" >
        Save Animals
      </div>
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
    </CHeaderNav>
    <CHeaderNav class="mr-4 align-items-center">      
      <CHeaderNavItem class="mx-2">
        <!-- <button class="header-notification-btn" title="Notifications">
          <CIcon name="cil-bell" />
          <span class="notification-badge"></span>
        </button> -->
      </CHeaderNavItem>
      <TheHeaderDropdownAccnt/>
    </CHeaderNav>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'

export default {
  name: 'TheHeader',
  components: {
    TheHeaderDropdownAccnt
  },
  computed: {
    currentPageTitle() {
      return this.$route && this.$route.name ? this.$route.name : 'Dashboard';
    }
  }
}
</script>
<style scoped>
  .breadcrumb {
    background-color: transparent !important;
  }
</style>